<div #acquisitionDisclaimerContainer class="quote-tool-lite__acquisition-disclaimer-container"></div>
<ng-container *ngIf="activeFlow$ | async as activeFlow">
  <ng-container *ngIf="navigationBarItems$ | async as navigationBarItems">
    <div class="step-wrapper__navigation-bar" *ngIf="navigationBarItems?.length">
      <lx-navigation-bar [activeFlow]="activeFlow" [items]="navigationBarItems"></lx-navigation-bar>
    </div>
  </ng-container>
  <div
    *ngIf="currentStep$ | async as step"
    class="step-wrapper__body"
    [ngClass]="
      {
      'step-wrapper__body--with-floating-panel': step.floatingPanel,
      'step-wrapper__body--with-floating-panel--title': step.floatingPanel?.position === 'title',
      'step-wrapper__body--with-floating-panel--content': step.floatingPanel?.position === 'content',
      'step-wrapper__body--with-floating-panel--enabled-mobile': step.floatingPanel?.enabledMobile,
      'step-wrapper__body--with-floating-panel--enabled-mobile--top': step.floatingPanel?.enabledMobile && step.floatingPanel?.mobilePosition === 'top',
      'step-wrapper__body--with-floating-panel--enabled-mobile--bottom': step.floatingPanel?.enabledMobile && step.floatingPanel?.mobilePosition === 'bottom',
      }
    "
  >
    <div class="step-wrapper__body__main__header">
      <div class="step-wrapper__body__main__header__title-row">
        <h1 class="step-wrapper__body__main__header__title" data-qa="pageTitle">{{ step?.title }}</h1>
        <lx-copy-selections-button
          *ngIf="step?.shareableDeeplink"
          [valid]="valid()"
          [copied]="copied()"
          (copyRequested)="handleCopyRequested()"
        ></lx-copy-selections-button>
      </div>
      <h2 class="step-wrapper__body__main__header__subtitle" *ngFor="let subtitle of step?.subtitles">
        {{ subtitle }}
      </h2>
    </div>
    <div class="step-wrapper__body__main__content">
      <router-outlet></router-outlet>
    </div>
    <div class="step-wrapper__body__main__footer" *ngIf="step?.nextButton">
      <lx-button
        id="btn-next"
        tabindex="0"
        [class.step-wrapper__body__main__footer--adult]="(activeFlow$ | async) === Flows.Adult"
        [class.step-wrapper__body__main__footer--junior]="(activeFlow$ | async) === Flows.Junior"
        [text]="step?.nextButton"
        [disabled]="!step?.valid"
        [block]="true"
        [btnRounded]="true"
        [buttonStyle]="'primary'"
        [lxNavigationToStep]="nextStep$ | async | async"
        [gaEvent]="nextDataLayerEventName"
        data-qa="next-button"
      >
      </lx-button>
    </div>

    <div
      class="step-wrapper__body__floating-panel"
      [ngClass]="
      {
      'step-wrapper__body__floating-panel--enabled-mobile': step.floatingPanel.enabledMobile,
      }
    "
      *ngIf="step.floatingPanel"
    >
      <ng-container *ngComponentOutlet="step?.floatingPanel?.component" />
    </div>
  </div>
</ng-container>
